import './styles.scss'
import PropTypes from 'prop-types'

const Alert = (props) => {
    return (
      <div className={'alert alert-' + props.type}>{props.children}</div>
    )
}

Alert.propTypes = {
  type: PropTypes.oneOf(['danger', 'success', 'warning', 'info']).isRequired,
  children: PropTypes.node,
}

export default Alert
